export function shouldRetryCsrfRequest(
  status: number | undefined,
  errorCode: string | undefined,
  alreadyRetried: boolean,
): boolean {
  return status === 403 && errorCode !== 'FORBIDDEN' && !alreadyRetried
}
